import { Pagination, Navigation } from 'swiper/modules';

const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length);
        }
    }
    return '';
};

const setCookie = (cname, cvalue, exdays) => {
    window.dataLayer.push({ occ: cvalue, event: 'onconsent' });
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

const deleteCookie = (cname) => {
    if (getCookie(cname) !== '') {
        document.cookie = cname + '=' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
}

const debounce = async (cb, delay = 500) => {
    let timeout

    return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            cb(...args)
        }, delay)
    }
}

const swiperConfig = {
    slidesPerView: 1.2,
    spaceBetween: 24,
    modules: [Pagination, Navigation],
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        // tablet
        640: {
            slidesPerView: 2.2,
        },
        // desktop
        1024: {
            slidesPerView: 3.2,
        },
    },
};

const adjustPaddingTop = () => {
    const boxElement = document.querySelector('.hero.has-overlay .box');
    const overlayedSections = document.querySelectorAll('.section--overlayed');

    if (boxElement && overlayedSections.length) {
        let boxHeight = boxElement.offsetHeight;
        let offset = window.innerWidth > 1024 ? (boxHeight / 2) : (boxHeight - 60);

        if (overlayedSections.length) {
            overlayedSections.forEach(section => {
                section.style.paddingTop = `${offset}px`;
            })
        }
    }
}

const activateAllTabs = () => {
    const tabs = document.querySelectorAll('.tabs .tab');
    const contents = document.querySelectorAll('.tab-content');

    const state = {
        activeTabs: [],
        activeContents: []
    };

    tabs.forEach(tab => {
        if (tab.classList.contains('is-active')) {
            state.activeTabs.push(tab.id);
        }
        tab.classList.add('is-active');
    });

    contents.forEach(content => {
        if (content.classList.contains('is-active')) {
            state.activeContents.push(content.id);
        }
        content.classList.add('is-active');
    });

    return state;
}

const restoreTabs = (state) => {
    const tabs = document.querySelectorAll('.tabs .tab');
    const contents = document.querySelectorAll('.tab-content');

    tabs.forEach(tab => {
        tab.classList.toggle('is-active', state.activeTabs.includes(tab.id));
    });

    contents.forEach(content => {
        content.classList.toggle('is-active', state.activeContents.includes(content.id));
    });
}

const activateAllAccordions = () => {
    const collapsibles = document.querySelectorAll('.is-collapsible');
    const triggers = document.querySelectorAll('.collapse-trigger');

    const state = {
        activeCollapsibles: [],
        activeTriggers: []
    };

    collapsibles.forEach(el => {
        if (el.classList.contains('is-active')) {
            state.activeCollapsibles.push(el);
        }

        el.classList.add('is-active');
        el.setAttribute('aria-expanded', 'true');
        el.style.height = 'auto';
    });

    triggers.forEach(trigger => {
        if (trigger.classList.contains('is-active')) {
            state.activeTriggers.push(trigger);
        }

        trigger.classList.add('is-active');
    });

    return state;
};

const restoreAccordions = (state) => {
    const collapsibles = document.querySelectorAll('.is-collapsible');
    const triggers = document.querySelectorAll('.collapse-trigger');

    collapsibles.forEach(el => {
        if (state.activeCollapsibles.includes(el)) {
            el.classList.add('is-active');
            el.setAttribute('aria-expanded', 'true');
            el.style.height = 'auto';
        } else {
            el.classList.remove('is-active');
            el.setAttribute('aria-expanded', 'false');
            el.style.height = '0px';
        }
    });

    triggers.forEach(trigger => {
        if (state.activeTriggers.includes(trigger)) {
            trigger.classList.add('is-active');
        } else {
            trigger.classList.remove('is-active');
        }
    });
};

export { setCookie, getCookie, deleteCookie, debounce, swiperConfig, adjustPaddingTop, activateAllTabs, restoreTabs, activateAllAccordions, restoreAccordions };
